import React, { useState } from 'react'
import { Box, Button, ButtonGroup, Typography } from '@mui/material';
import SettingsIntermediate from '../SettingsIntermediate'
import userPermissions from '../../User/Permissions';
import { getSession } from '../../../auth';
import VoiceComponent from '../../Settings/Voice'
import VoiceTable from '../../Settings/Voice/voice-table';
import VoiceUras from '../../Settings/Voice/VoiceUras';
import VoiceExternalResources from '../../Settings/Voice/VoiceExternalResources';
import UsersQueue from '../../Settings/Users/UsersQueue';

const PhonePage = () => {
    const groups = userPermissions();
    const enterprise = getSession()?.profile?.enterprise
    const [voiceBackend, setVoiceBackend] = useState('EXTERNAL')
    const isExternal = voiceBackend === 'EXTERNAL'

    const BackendSelector = (
        <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Telefonia
            </Typography>
            <ButtonGroup size="small">
                <Button
                    variant={isExternal ? 'contained' : 'outlined'}
                    onClick={() => setVoiceBackend('EXTERNAL')}
                >
                    Externa
                </Button>
                <Button
                    variant={!isExternal ? 'contained' : 'outlined'}
                    onClick={() => setVoiceBackend('LOCAL')}
                >
                    Interna
                </Button>
            </ButtonGroup>
        </Box>
    )

    return (
        <>
            <SettingsIntermediate title='Telefonia' components={() => ({
                comp1:{
                    permissions: true,
                    style:'title',
                    label:'Telefonia'
                },
                comp2:{
                    permissions: groups.isAdmin,
                    style:'free',
                    redirect: BackendSelector,
                },
                comp3:{
                    permissions: groups.isAdmin,
                    style:'list',
                    label:"Mensagens",
                    sublabel:"Configure as mensagens pre-programadas para a telefonia",
                    redirect: (<VoiceComponent enterpriseId={enterprise?.id}/>),
                    isVisible: !isExternal,
                },
                comp4:{
                    permissions: groups.isAdmin,
                    style:'list',
                    label:"Números",
                    sublabel:"Configure os números para a telefonia",
                    redirect: (<VoiceTable enterpriseId={enterprise?.id}/>),
                    isVisible: !isExternal,
                },
                comp5:{
                    permissions: groups.isAdmin,
                    style:'list',
                    label: isExternal ? "URAs externas" : "URAs",
                    sublabel: isExternal ? "Consulte URAs existentes no InstantVoice externo" : "Crie e edite URAs de voz no VIVRE",
                    redirect: isExternal ? (<VoiceExternalResources enterpriseId={enterprise?.id} resource="uras" />) : (<VoiceUras />),
                },
                comp6:{
                    permissions: groups.isSupervisor,
                    style:'list',
                    label: isExternal ? "Filas externas" : "Filas de voz",
                    sublabel: isExternal ? "Consulte filas existentes no InstantVoice externo" : "Configure as filas de atendimento por voz e seus operadores",
                    redirect: isExternal ? (<VoiceExternalResources enterpriseId={enterprise?.id} resource="queues" />) : (<UsersQueue enterpriseId={enterprise?.id} voiceOnly={true}/>),
                }
            })
            } />
        </>
    )
}


export default PhonePage
